// HO-TASK-290: cómo se muestran en la campana las notificaciones de Homelan
// Rewards. El backend (HO-TASK-278, RewardNotificationService) las escribe en
// la misma tabla de notificaciones que el resto del sistema, con tipos
// `rewards-*` y el texto listo en `data.message`.

export const REWARDS_ROUTE = '/dashboard/rewards'
const PAY_ROUTE = '/dashboard/my/finance/topays'

export const REWARDS_NOTIFICATION_TYPES = {
  'rewards-points': { emoji: '🪙', label: 'Coins ganados' },
  'rewards-level': { emoji: '🏆', label: 'Nuevo nivel' },
  'rewards-streak': { emoji: '🔥', label: 'Racha' },
  'rewards-streak-broken': { emoji: '🧊', label: 'Racha interrumpida' },
  // El recordatorio llega antes del día límite con la cuota sin pagar: lleva
  // directo a pagar, que es lo único que conserva la racha.
  'rewards-streak-at-risk': { emoji: '⏰', label: 'Racha en riesgo', route: PAY_ROUTE },
  'rewards-redemption': { emoji: '🎁', label: 'Canje' },
  'rewards-tickets': { emoji: '🎟️', label: 'Tickets del sorteo' }
}

export const isRewardsNotification = (type) => typeof type === 'string' && type.startsWith('rewards-')

export const parseNotificationData = (notification) => {
  if (!notification?.data) return {}
  if (typeof notification.data === 'object') return notification.data
  try {
    return JSON.parse(notification.data) || {}
  } catch (error) {
    return {}
  }
}

// Presentación de una notificación de Rewards; null si es de otro tipo.
export const getRewardsNotificationView = (notification) => {
  if (!isRewardsNotification(notification?.type)) return null
  const config = REWARDS_NOTIFICATION_TYPES[notification.type] || { emoji: '🏅', label: 'Homelan Rewards' }
  const data = parseNotificationData(notification)
  return {
    emoji: config.emoji,
    label: config.label,
    route: config.route || REWARDS_ROUTE,
    message: data.message || 'Tienes novedades en Homelan Rewards.',
    data
  }
}

// El texto de las notificaciones se muestra como HTML en la campana
// (Notification usa dangerouslySetInnerHTML). El de Rewards es texto plano que
// incluye nombres configurables, como el del nivel, así que se escapa.
export const escapeHtml = (text) =>
  String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

// Contenido para <Notification content>: etiqueta del programa y el mensaje.
export const buildRewardsNotificationContent = (view) =>
  `<span class="badge badge-soft-primary rounded-capsule fs--2 mb-1">Homelan Rewards · ${escapeHtml(view.label)}</span><br/>${escapeHtml(view.message)}`
